<template>
  <section
    class="sticky-top"
    v-if="
      $route.name !== 'Seat Layout' &&
        $route.name !== 'Food and Drinks Checkout' &&
        $route.name !== 'Booking Summary' &&
        $route.name !== 'Final Ticket' &&
        $route.name !== 'Regular Booking' &&
        $route.name !== 'Pay Now' &&
        $route.name !== 'Home Page'
    "
  >
    <div class="d-flex align-items-center py-3 bg-dark text-white px-3">
      <div>
        <img
          src="@/assets/img/icons/back-arrow.svg"
          alt
          @click="$router.go(-1)"
        />
      </div>
      <div class="flex-grow-1 text-center">{{ routerName }}</div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    routerName() {
      return this.$store.state.AppSetting.routerName;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/mobileHeader.vue